import React, { FunctionComponent } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Product } from '../../../pages/DashBoard/DashBoardScreen'
import { MainState } from '../../../redux/reducers'
import { ProductData } from '../../../redux/requests/products/product.types'
import * as S from './styled'

type OwnProps = {
  productData: ProductData[]
}

type Props = OwnProps

export const ProductDropDown: FunctionComponent<Props> = ({ productData }) => {
  const dispatch = useDispatch()
  const product = useSelector((state: MainState) => state.misc.product)

  const user = useSelector((state: MainState) => state.misc.user)
  const translations: Record<Product, string> = {
    [Product.WHEAT]: 'Vete',
    [Product.RAPESEED]: 'Raps',
    [Product.OATS]: 'Havre',
    [Product.EGG]: 'Ägg',
    [Product.DIESEL]: 'Diesel',
    [Product.FODER]: 'Foder',
  }

  function changeHandler(event: any) {
    const value = event.target.options[event.target.options.selectedIndex].value
    dispatch({ type: 'SET_PRODUCT', product: value === 'egg' ? 'EGGS' : value })
  }
  const availableProdcuts = Array.from(new Set(productData.map(product => product.product))).filter(
    item => item !== 'foder',
  )

  return (
    <S.Card>
      <S.Text>Produkt:</S.Text>
      <S.DropDown onChange={changeHandler} value={product ? product : user.defaultProduct}>
        <option value={user.defaultProduct}>{translations[user.defaultProduct]}</option>
        {availableProdcuts.map(item => {
          return (
            item.toLowerCase() !== user.defaultProduct.toLowerCase() && (
              <option key={item} value={item}>
                {translations[item]}
              </option>
            )
          )
        })}
      </S.DropDown>
    </S.Card>
  )
}

export default ProductDropDown
